import React from "react";
import { t } from "../../../core/translate";
import { Button, TextField, Form } from "@vitalsource/vstui";
import Recaptcha from "../recaptcha";
import Clever from "./clever";
import SharedLinks from "../shared-links";
import Instructions from "./instructions";
import { connect } from "react-redux";
import WelcomeText from "../welcome-text";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { selectors as routerSelectors } from "../../../../redux/router";
import { selectors as localeSelectors } from "../../../../redux/locale";
import { emailPattern } from "../utils";
import SimplifiedInterstitial from "../../library/download-native-app";
import { showInterstitialScreen } from "../../../utils/read-offline";

import FormAlert from "../form-alert";
import ContainerLayout from "../container-layout";

class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      captcha: props.captcha,
      email: props.defaultEmail,
      hasContinuedToMobileSite: false
    };
    this.loginFailureRef = React.createRef();
    this.loginErrorRef = React.createRef();
  }

  _startRecaptcha() {
    this.setState({
      captcha: true
    });
  }

  onEmailChange = e => {
    const email = e.currentTarget.value;
    this.setState({ email });
    if (
      !this.state.captcha &&
      /vpg|ingram|vitalsource|vitalbook|lightning/i.test(email)
    ) {
      this._startRecaptcha();
    }
  };

  validateSubmit = e => {
    if (this.state.captcha) {
      const recaptchaResponse = document.getElementById("g-recaptcha-response");
      if (recaptchaResponse && !recaptchaResponse.value) {
        e.preventDefault();
        this.setState({ recaptchaRequired: true });
      } else {
        this.setState({ recaptchaRequired: false });
      }
    }
  };

  renderSignIn() {
    const {
      signInEnabled,
      protocol,
      jigsawHost,
      jigsawBrand,
      redirectBase,
      redirectRoute,
      locale,
      defaultEmail,
      captchaKey,
      captchaToken
    } = this.props;
    if (signInEnabled) {
      return (
        <Form
          onSubmit={this.validateSubmit}
          id="signin-form"
          method="post"
          action={`${protocol}//${jigsawHost}/login`}
          noValidate
        >
          <TextField
            required
            fullWidth
            id="email-field"
            type="email"
            name="user[email]"
            label={t("base.email", "Email Address")}
            size="large"
            onChange={this.onEmailChange}
            defaultValue={defaultEmail}
            pattern={emailPattern}
          />
          <TextField
            required
            fullWidth
            id="password-field"
            type="password"
            name="user[password]"
            label={t("base.password", "Password")}
            size="large"
          />
          <input
            type="hidden"
            name="return"
            id="login-return"
            value={`${redirectBase}${redirectRoute.relative}`}
          />
          <input
            type="hidden"
            name="failure"
            id="login-return-failure"
            ref={this.loginFailureRef}
            value={`${redirectBase}/user/signin?email=${this.state.email}&error=true`}
          />
          <input
            type="hidden"
            name="error"
            id="login-return-error"
            ref={this.loginErrorRef}
            value={`${redirectBase}/user/signin?email=${this.state.email}&error=true`}
          />
          <input
            type="hidden"
            name="jigsaw_brand"
            id="jigsaw-brand"
            value={jigsawBrand}
          />
          {this.state.captcha && (
            <Recaptcha
              locale={locale}
              captchaKey={captchaKey}
              captchaToken={captchaToken}
            />
          )}
          <Button id="submit-btn" fullWidth size="large">
            {t("signin.signin-button")}
          </Button>
        </Form>
      );
    }
    return null;
  }

  render() {
    if (showInterstitialScreen() && !this.state.hasContinuedToMobileSite) {
      return (
        <SimplifiedInterstitial
          continueToMobileSite={() =>
            this.setState({ hasContinuedToMobileSite: true })
          }
        />
      );
    }
    return (
      <ContainerLayout
        graphic="signin"
        pageTitle={t("signin.signin-button", "Sign In")}
        title={<WelcomeText />}
      >
        {this.props.authenticationError && (
          <FormAlert level="error" key="signinerror">
            {t("signin.failure", "Incorrect email or password")}
          </FormAlert>
        )}
        {this.state.recaptchaRequired && (
          <FormAlert level="error" key="recaptcharequired">
            {t("signin.recaptcha", "Please fill out the recaptcha")}
          </FormAlert>
        )}
        <Clever />
        <Instructions />
        {this.renderSignIn()}
        <SharedLinks forgotPassword register />
      </ContainerLayout>
    );
  }
}

const mapStateToProps = state => ({
  signInEnabled: brandSelectors.getBrandValue(state, "Signin.enabled", true),
  protocol: Fraction.Environment.sslSignin ? "https:" : "",
  jigsawBrand: brandSelectors.getBrandValue(
    state,
    "jigsawBrand",
    "vitalsource"
  ),
  jigsawHost:
    brandSelectors.getBrandValue(state, "jigsawHost", null) ||
    Fraction.Environment.jigsawRootURL.slice(2, -1),
  redirectBase: routerSelectors.getRootRoute(state),
  redirectRoute: routerSelectors.getRedirectRoute(state) || { relative: "/" },
  captcha: routerSelectors.getQueryParam(state, "captcha"),
  captchaKey: routerSelectors.getQueryParam(state, "captcha_key"),
  captchaToken: routerSelectors.getQueryParam(state, "captcha_token"),
  defaultEmail: routerSelectors.getQueryParam(state, "email"),
  authenticationError: routerSelectors.getQueryParam(state, "error"),
  locale: localeSelectors.getCurrentLocale(state),
  isNative: routerSelectors.isNative(state)
});

const ConnectedSignin = connect(mapStateToProps)(SignIn);

export default ConnectedSignin;
